import { ScoreChipLevel } from './score-chip-level.enum';

export const SCORE_CHIP_INSUFFICIENT_DATA = -1;
export const SCORE_CHIP_ERROR = -2;

const SCORE_CHIP_THRESHOLDS: ReadonlyArray<readonly [number, ScoreChipLevel]> = [
  [4.8, ScoreChipLevel.EXCELLENT_MATCH],
  [4.25, ScoreChipLevel.VERY_GOOD_MATCH],
  [3.0, ScoreChipLevel.GOOD_MATCH],
  [0, ScoreChipLevel.NO_MATCH],
];

/**
 * Maps a numeric match score to the visual score-chip level.
 * @param score - Screening score, `-1` for incomplete data, `-2` for errors
 * @returns Matching visual level
 */
export function resolveScoreChipLevel(score: number | undefined): ScoreChipLevel {
  if (score === SCORE_CHIP_ERROR) {
    return ScoreChipLevel.ERROR;
  }
  if (score === SCORE_CHIP_INSUFFICIENT_DATA) {
    return ScoreChipLevel.INSUFFICIENT_DATA;
  }
  if (score === undefined || score === null) {
    return ScoreChipLevel.NO_MATCH;
  }
  for (const [threshold, level] of SCORE_CHIP_THRESHOLDS) {
    if (score >= threshold) {
      return level;
    }
  }
  return ScoreChipLevel.NO_MATCH;
}
